/* MLS mega menu (replaces the Buddha Mega Menu app, 10-12-26).
   Hover and keyboard focus are handled in CSS. This adds tap support for touch screens
   wide enough to show the desktop menu: the first tap on a parent opens it, the second
   tap follows the link. Escape or a tap outside closes everything. */
(() => {
  const menu = document.querySelector('full-menu');
  if (!menu) return;
  const parents = menu.querySelectorAll('.mls-mega-item, .mls-mega__item--parent');
  const closeAll = (keep) => {
    parents.forEach((li) => {
      if (!keep || !li.contains(keep)) li.classList.remove('is-open');
    });
  };

  parents.forEach((li) => {
    const link = li.querySelector(':scope > a');
    if (!link) return;
    link.addEventListener('click', (event) => {
      if (!window.matchMedia('(hover: none)').matches) return;
      if (li.classList.contains('is-open')) return;
      event.preventDefault();
      closeAll(li);
      li.classList.add('is-open');
    });
  });

  document.addEventListener('click', (event) => {
    if (!menu.contains(event.target)) closeAll();
  });
  menu.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeAll();
    if (menu.contains(document.activeElement)) document.activeElement.blur();
  });
})();
